import type { IErrorBoundaryErrorInfo } from "./error-boundary.models";

export const formatErrorBoundaryReport = ({
  error,
  errorInfo,
}: {
  error: Error;
  errorInfo: IErrorBoundaryErrorInfo | null;
}): string => {
  const lines: string[] = [];

  lines.push(`${error.name}: ${error.message}`);

  if (error.stack) {
    lines.push("");
    lines.push(error.stack);
  }

  if (errorInfo?.componentStack) {
    lines.push("");
    lines.push("Component stack:");
    lines.push(errorInfo.componentStack.trim());
  }

  return lines.join("\n");
};
